

function getTeamFieldSchemasQuery(teamId) {
  return [
    ['teamId', '==', teamId],
    ['isDeleted', '==', false]
  ]
}

export { getTeamFieldSchemasQuery }